import Vue from 'vue';
import Vuex from 'vuex';
import { authAPI } from '../utils/api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    isAuthenticated: false,
    token: localStorage.getItem('token') || null,
    sidebarVisible: localStorage.getItem('sidebarVisible') !== 'false',
    userManuallyToggled: localStorage.getItem('userManuallyToggled') === 'true',
    lastWidth: window.innerWidth,
    sdkReady: false,
    sdkError: null,
    ihubReady: false,
    ihubError: null,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    },
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
    setSidebarVisible(state, visible) {
      state.sidebarVisible = visible;
      localStorage.setItem('sidebarVisible', visible);
    },
    setUserManuallyToggled(state, toggled) {
      state.userManuallyToggled = toggled;
      localStorage.setItem('userManuallyToggled', toggled);
    },
    setLastWidth(state, width) {
      state.lastWidth = width;
    },
    SET_SDK_READY(state, ready) {
      state.sdkReady = ready;
    },
    SET_SDK_ERROR(state, error) {
      state.sdkError = error;
    },
    SET_IHUB_READY(state, ready) {
      state.ihubReady = ready;
    },
    SET_IHUB_ERROR(state, error) {
      state.ihubError = error;
    },
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await authAPI.login(credentials);
        const { user, token } = response.data;
        commit('SET_USER', user);
        commit('SET_TOKEN', token);
        return true;
      } catch (error) {
        commit('SET_USER', null);
        commit('SET_TOKEN', null);
        throw error;
      }
    },
    async logout({ commit }) {
      try {
        await authAPI.logout();
      } finally {
        commit('SET_USER', null);
        commit('SET_TOKEN', null);
      }
    },
    toggleSidebar({ commit, state }) {
      commit('setUserManuallyToggled', true);
      commit('setSidebarVisible', !state.sidebarVisible);
    },
    setSidebarVisible({ commit }, visible) {
      commit('setSidebarVisible', visible);
    },
    setUserManuallyToggled({ commit }, toggled) {
      commit('setUserManuallyToggled', toggled);
    },
    updateLastWidth({ commit }, width) {
      commit('setLastWidth', width);
    },
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    currentUser: state => state.user
  }
}); 